/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { BatchUpdateBusinessTypeEbsConfigRequest } from '../models/batch-update-business-type-ebs-config-request';
import { BusinessType } from '../models/business-type';
import { BusinessTypeEbsConfigResponse } from '../models/business-type-ebs-config-response';
import { CreateBusinessTypeEbsConfigRequest } from '../models/create-business-type-ebs-config-request';
import { GenericResponse } from '../models/generic-response';
import { GetBusinessTypeEbsConfigResponse } from '../models/get-business-type-ebs-config-response';
import { UpdateBusinessTypeEbsConfigRequest } from '../models/update-business-type-ebs-config-request';

/**
 * Business Type EBS Config APIs
 */
@Injectable({ providedIn: 'root' })
export class BusinessTypeEbsConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBusinessTypeEbsConfigs()` */
  static readonly GetBusinessTypeEbsConfigsPath =
    '/api/v1/business-type-ebs-configs';

  /**
   * fetch business type ebs configs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessTypeEbsConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsConfigs$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to following fields:
       *   - businessType
       *   - Ebs config
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetBusinessTypeEbsConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.GetBusinessTypeEbsConfigsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetBusinessTypeEbsConfigResponse>;
        })
      );
  }

  /**
   * fetch business type ebs configs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessTypeEbsConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsConfigs(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to following fields:
       *   - businessType
       *   - Ebs config
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetBusinessTypeEbsConfigResponse> {
    return this.getBusinessTypeEbsConfigs$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetBusinessTypeEbsConfigResponse>
        ): GetBusinessTypeEbsConfigResponse => r.body
      )
    );
  }

  /** Path part for operation `createBusinessTypeEbsConfig()` */
  static readonly CreateBusinessTypeEbsConfigPath =
    '/api/v1/business-type-ebs-configs';

  /**
   * create business type ebs config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBusinessTypeEbsConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBusinessTypeEbsConfig$Response(
    params: {
      body: CreateBusinessTypeEbsConfigRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.CreateBusinessTypeEbsConfigPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsConfigResponse>;
        })
      );
  }

  /**
   * create business type ebs config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBusinessTypeEbsConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBusinessTypeEbsConfig(
    params: {
      body: CreateBusinessTypeEbsConfigRequest;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsConfigResponse> {
    return this.createBusinessTypeEbsConfig$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsConfigResponse>
        ): BusinessTypeEbsConfigResponse => r.body
      )
    );
  }

  /** Path part for operation `batchUpdateBusinessTypeEbsConfigs()` */
  static readonly BatchUpdateBusinessTypeEbsConfigsPath =
    '/api/v1/business-type-ebs-configs';

  /**
   * Patch multiple BusinessType EBS configs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `batchUpdateBusinessTypeEbsConfigs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  batchUpdateBusinessTypeEbsConfigs$Response(
    params: {
      body: Array<BatchUpdateBusinessTypeEbsConfigRequest>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.BatchUpdateBusinessTypeEbsConfigsPath,
      'patch'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsConfigResponse>;
        })
      );
  }

  /**
   * Patch multiple BusinessType EBS configs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `batchUpdateBusinessTypeEbsConfigs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  batchUpdateBusinessTypeEbsConfigs(
    params: {
      body: Array<BatchUpdateBusinessTypeEbsConfigRequest>;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsConfigResponse> {
    return this.batchUpdateBusinessTypeEbsConfigs$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsConfigResponse>
        ): BusinessTypeEbsConfigResponse => r.body
      )
    );
  }

  /** Path part for operation `getBusinessTypeEbsConfigById()` */
  static readonly GetBusinessTypeEbsConfigByIdPath =
    '/api/v1/business-type-ebs-configs/{id}';

  /**
   * fetch business type ebs configs details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessTypeEbsConfigById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsConfigById$Response(
    params: {
      /**
       * The business type ebs config id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.GetBusinessTypeEbsConfigByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsConfigResponse>;
        })
      );
  }

  /**
   * fetch business type ebs configs details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessTypeEbsConfigById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsConfigById(
    params: {
      /**
       * The business type ebs config id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsConfigResponse> {
    return this.getBusinessTypeEbsConfigById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsConfigResponse>
        ): BusinessTypeEbsConfigResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteBusinessTypeEbsConfigById()` */
  static readonly DeleteBusinessTypeEbsConfigByIdPath =
    '/api/v1/business-type-ebs-configs/{id}';

  /**
   * Delete Business Type Ebs Config  by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBusinessTypeEbsConfigById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBusinessTypeEbsConfigById$Response(
    params: {
      /**
       * The Business Type Ebs Config id that needs to be delete
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.DeleteBusinessTypeEbsConfigByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete Business Type Ebs Config  by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBusinessTypeEbsConfigById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBusinessTypeEbsConfigById(
    params: {
      /**
       * The Business Type Ebs Config id that needs to be delete
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteBusinessTypeEbsConfigById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateBusinessTypeEbsConfigById()` */
  static readonly UpdateBusinessTypeEbsConfigByIdPath =
    '/api/v1/business-type-ebs-configs/{id}';

  /**
   * update Business Type Ebs Config by id.
   *
   * update Business Type Ebs Config
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBusinessTypeEbsConfigById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBusinessTypeEbsConfigById$Response(
    params: {
      /**
       * The business type ebs config id that needs to be updated
       */
      id: number;
      body: UpdateBusinessTypeEbsConfigRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.UpdateBusinessTypeEbsConfigByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsConfigResponse>;
        })
      );
  }

  /**
   * update Business Type Ebs Config by id.
   *
   * update Business Type Ebs Config
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBusinessTypeEbsConfigById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBusinessTypeEbsConfigById(
    params: {
      /**
       * The business type ebs config id that needs to be updated
       */
      id: number;
      body: UpdateBusinessTypeEbsConfigRequest;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsConfigResponse> {
    return this.updateBusinessTypeEbsConfigById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsConfigResponse>
        ): BusinessTypeEbsConfigResponse => r.body
      )
    );
  }

  /** Path part for operation `getBusinessTypeEbsConfigByBusinessType()` */
  static readonly GetBusinessTypeEbsConfigByBusinessTypePath =
    '/api/v1/business-type-ebs-configs/{businessType}/business-type';

  /**
   * fetch business type ebs configs details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessTypeEbsConfigByBusinessType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsConfigByBusinessType$Response(
    params: {
      /**
       * The business type ebs config id that needs to be fetched
       */
      businessType: BusinessType;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BusinessTypeEbsConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      BusinessTypeEbsConfigService.GetBusinessTypeEbsConfigByBusinessTypePath,
      'get'
    );
    if (params) {
      rb.path('businessType', params.businessType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<BusinessTypeEbsConfigResponse>;
        })
      );
  }

  /**
   * fetch business type ebs configs details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessTypeEbsConfigByBusinessType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessTypeEbsConfigByBusinessType(
    params: {
      /**
       * The business type ebs config id that needs to be fetched
       */
      businessType: BusinessType;
    },
    context?: HttpContext
  ): Observable<BusinessTypeEbsConfigResponse> {
    return this.getBusinessTypeEbsConfigByBusinessType$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<BusinessTypeEbsConfigResponse>
        ): BusinessTypeEbsConfigResponse => r.body
      )
    );
  }
}
